export default {
  Reports: {
    Cortex: {
      RefoundCount: 'برگشت از خرید',
      PureBuy: 'خالص خرید',
      ReadyForSell: 'کالای اماده فروش',
      StartPeriodDollarAvg: 'میانگین قیمت اول دوره دلاری',
      StartPeriodIrrAvg: 'میانگین قیمت اول دوره ریالی',
      BuyDollarAvg: 'میانگین مبلغ خرید دلاری',
      BuyIrrAvg: 'میانگین مبلغ خرید ریالی',
      SellDollarAvg: 'میانگین قیمت فروش یک واحد دلاری',
      SellIrrAvg: 'میانگین قیمت فروش یک واحد ریالی',
    },
    Deliveries: {
      Title: 'زمان تحویل محصول',
      Percent: 'درصد',
      Product: 'محصول',
      Total: 'کل',
      Between_0_10_min: 'بین صفر تا ده دقیقه',
      Between_11_30_min: 'بین ده تا نیم ساعت',
      Between_31_60_min: 'بین نیم تا یک ساعت',
      Between_61_120_min: 'بین یک تا دو ساعت',
      Between_121_240_min: 'بین دو تا چهار ساعت',
      Between_241_480_min: 'بین چهار تا هشت ساعت',
      More_than_480_min_min: 'بیشتر از هشت ساعت',
    },
    Yearly: {
      Months: {
        Twelve: 'یک ساله',
        Six: 'شش ماهه',
        One: 'یک ماهه',
        Two: 'دو ماهه',
        Three: 'سه ماهه',
        Four: 'چهار ماهه',
        Five: 'پنج ماهه',
        Nine: 'نه ماهه',
      },
      AmountToman: 'فروش تومانی',
      AmountDollar: 'فروش دلاری',
      Count: 'تعداد فروش',
      Title: 'گزارش فروش',
      churn: 'تعداد کاربران ریزشی',
    },
    CallReport: {
      TotalCall: 'کل تماس‌ها',
      SuccessCall: 'تماس با پاسخ',
      UnSuccessCall: 'تماس بدون پاسخ',
      SuccessPaymentsCount: 'پرداخت موفق',
      ConversionRate: 'نرخ تماس',
    },
  },
}
